import React, { useEffect, useState } from "react";
import { BarChart3, Eye } from "lucide-react";
import api from "@/lib/api";

/** "Resume Analytics" -- total views + a 14-day view trend for the learner's public shareable
 * resume link (see ShareResumeCard.js). Renders nothing if no share link exists yet. */
export default function ResumeAnalyticsCard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/resume-builder/share/analytics").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data || !data.share_id) return null;

  const maxViews = Math.max(1, ...data.daily_trend.map((d) => d.views));

  return (
    <div className="glass-panel rounded-2xl p-4" data-testid="resume-analytics-card">
      <h3 className="flex items-center gap-2 text-sm font-heading font-semibold text-white mb-3">
        <BarChart3 className="w-4 h-4 text-indigo-400" /> Resume Analytics
      </h3>
      <div className="grid grid-cols-2 gap-2 mb-3">
        <div className="bg-white/[0.03] rounded-xl p-2.5 text-center" data-testid="resume-analytics-total-views">
          <div className="flex items-center justify-center gap-1 text-white"><Eye className="w-3.5 h-3.5 text-indigo-400" /><span className="font-heading text-xl font-bold">{data.view_count}</span></div>
          <p className="text-[10px] text-slate-400 mt-0.5">Total Views</p>
        </div>
        <div className="bg-white/[0.03] rounded-xl p-2.5 text-center">
          <p className="font-heading text-xl font-bold text-white">{data.last_viewed_at ? new Date(data.last_viewed_at).toLocaleDateString() : "—"}</p>
          <p className="text-[10px] text-slate-400 mt-0.5">Last Viewed</p>
        </div>
      </div>

      {data.view_count === 0 ? (
        <p className="text-xs text-slate-400 text-center py-1">No views yet — share your resume link to start tracking traffic.</p>
      ) : (
        <div data-testid="resume-analytics-trend">
          <p className="text-[10px] font-bold uppercase tracking-wider text-slate-400 mb-2">Last 14 Days</p>
          <div className="flex items-end gap-1 h-14">
            {data.daily_trend.map((d) => (
              <div key={d.date} className="flex-1 bg-indigo-500/70 rounded-sm hover:bg-indigo-400 transition-colors" style={{ height: `${Math.max(4, (d.views / maxViews) * 100)}%` }} title={`${d.date}: ${d.views} view${d.views === 1 ? "" : "s"}`} data-testid={`resume-analytics-bar-${d.date}`} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
